(function () {
    "use strict";

    let activeTabTarget = null;

    function rememberActiveTab() {
        const activeTab = document.querySelector("[role='tab'].active");
        activeTabTarget = activeTab ? activeTab.getAttribute("data-tw-target") : null;
    }

    function restoreActiveTab() {
        if (!activeTabTarget) {
            return;
        }

        const tab = document.querySelector(`[role='tab'][data-tw-target="${activeTabTarget}"]`);

        if (tab && !tab.classList.contains("active")) {
            window.tailwind?.Tab?.getInstance(tab)?.show();
        }
    }

    document.addEventListener("livewire:load", () => {
        Livewire.hook("message.sent", rememberActiveTab);
        Livewire.hook("message.processed", restoreActiveTab);
    });
})();
